import { AxiosService, getDateFormat } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import {
  NullReportCreationType,
  PatientAndReportCreationType,
  ReportCreationType,
} from '@/shared/types'
import { DATE_FORMAT } from '@/shared/constants'

class ReportCreationApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public createReport(reportData: ReportCreationType) {
    const {
      date,
      patientId,
      images,
      stone,
      pigmented,
      caries,
      filling,
      extracted,
      image_rotations,
    } = reportData

    const formData = new FormData()

    formData.append('date_at', getDateFormat(date, DATE_FORMAT.dmyDot))
    formData.append('patient_id', patientId.toString())
    formData.append('pigmented', pigmented.toString())
    formData.append('image_rotations', JSON.stringify(image_rotations))
    if (caries || caries == '0') {
      formData.append('caries', caries)
    }
    if (filling || filling == '0') {
      formData.append('filling', filling)
    }
    if (extracted || extracted == '0') {
      formData.append('extracted', extracted)
    }

    stone.forEach((item) => {
      formData.append('stone[]', item.toString())
    })

    images.forEach((image) => {
      formData.append('images[]', image)
    })

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/create',
      data: formData,
    })
  }

  public createReportNull(reportData: NullReportCreationType) {
    const {
      date,
      stone,
      pigmented,
      images,
      caries,
      filling,
      extracted,
      image_rotations,
    } = reportData

    const formData = new FormData()

    formData.append('date_at', getDateFormat(date, DATE_FORMAT.dmyDot))
    formData.append('pigmented', pigmented.toString())
    formData.append('image_rotations', JSON.stringify(image_rotations))
    if (caries || caries == '0') {
      formData.append('caries', caries)
    }
    if (filling || filling == '0') {
      formData.append('filling', filling)
    }
    if (extracted || extracted == '0') {
      formData.append('extracted', extracted)
    }

    stone.forEach((item) => {
      formData.append('stone[]', item.toString())
    })

    images.forEach((image) => {
      formData.append('images[]', image)
    })

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/create-for-null-patient',
      data: formData,
    })
  }

  public createPatientAndReport(reportData: PatientAndReportCreationType) {
    const formData = this.getFormDataForCreatePatientAndReport(reportData)

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/create-patient-and-report',
      data: formData,
    })
  }

  private getFormDataForCreatePatientAndReport(
    reportData: PatientAndReportCreationType
  ): FormData {
    const {
      dateAt,
      cartNumber,
      stone,
      images,
      image_rotations,
      surname,
      name,
      patronymic,
      email,
      phone,
      date,
      pigmented,
      caries,
      filling,
      extracted,
    } = reportData

    const formData = new FormData()

    formData.append('date_at', getDateFormat(dateAt, DATE_FORMAT.dmyDot))
    formData.append('cart_number', cartNumber)
    formData.append('surname', surname)
    formData.append('name', name)
    formData.append('date', getDateFormat(date, DATE_FORMAT.dmyDot))
    formData.append('pigmented', pigmented.toString())
    formData.append('image_rotations', JSON.stringify(image_rotations))
    if (caries || caries == '0') {
      formData.append('caries', caries)
    }
    if (filling || filling == '0') {
      formData.append('filling', filling)
    }
    if (extracted || extracted == '0') {
      formData.append('extracted', extracted)
    }

    stone.forEach((item) => {
      formData.append('stone[]', item.toString())
    })

    images.forEach((image) => {
      formData.append('images[]', image)
    })

    if (patronymic) {
      formData.append('patronymic', patronymic)
    }

    if (email) {
      formData.append('email', email)
    }

    if (phone) {
      formData.append('phone', phone)
    }

    return formData
  }
}

export const reportCreationApi = new ReportCreationApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
